/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlanSyncStatus {
    getFixupPrototypeFunction() { return BillingPlanSyncStatus.fixupPrototype; }

    static newInstance(model: Partial<BillingPlanSyncStatus>): BillingPlanSyncStatus {
        let obj = Object.assign(new BillingPlanSyncStatus(), model);
        BillingPlanSyncStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlanSyncStatus>): BillingPlanSyncStatus {
        if (!model) return null;
        return BillingPlanSyncStatus.newInstance(<BillingPlanSyncStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlanSyncStatus) {
        if (!obj) return;

        models.BillingPlanSyncStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlanSyncStatus): boolean {
        Object.setPrototypeOf(obj, BillingPlanSyncStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service account ID
     */
    sys_id: string;

    /**
     * Status of the billing plan execution
     */
    status: models.BillingPlanExecutionStatus;

    /**
     * Message related to the billing plan status
     */
    message: string;

}
